var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo-app"},[_c('div',{staticClass:"demo-app-main",staticStyle:{"position":"relative"}},[_c('FullCalendar',{ref:"calendars",staticClass:"demo-app-calendar",attrs:{"options":_vm.calendarOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }